import { render, staticRenderFns } from "./LineChartB.vue?vue&type=template&id=10b6d2f2&"
import script from "./LineChartB.vue?vue&type=script&lang=js&"
export * from "./LineChartB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports